import {BaseAnalyticsEvent} from "./base-analytics-event";

export class VisitEvent extends BaseAnalyticsEvent {
  _properties: Object;

  constructor(properties) {
    super('', '', 'visit');

    this._properties = properties;
  }

  get properties() {
    return this._properties;
  }
}
